module.exports = __webpack_public_path__ + "img/union-pay-small.2fc45927.png";